import React from "react"
import './index.css';
import Icon from '../../artzu-ui/src/Icon'

const BookingHeader = ({ display, heading, selectedShifts, editFilter, backAction, showModal}) => (
  <div className="book-head">
    {display === "confirmation" ? <div className="heading-filler"></div> : (display === "complete" ?
    <a href="/book">
      <Icon size="sm" name="BackArrow" color="#414141" />
    </a> : 
    <a href="javascript:void(0)" onClick={selectedShifts.length > 0 && display === "calendar" ? showModal : backAction}>
      <Icon size={display === "editFilter" ? "xs" : "sm"} name={display === "editFilter" ? "Close" : "BackArrow"} color="#414141" />
    </a>)}
    {heading}
    {display === "calendar" ? 
    <a href="javascript:void(0)" onClick={editFilter}>
      <Icon size="sm" name="Filter" color="#414141" />
    </a> : <div className="heading-filler"></div>}
  </div>
)

export default BookingHeader;


// WEBPACK FOOTER //
// ./src/components/NewBook/BookingHeader.js